/* ============================================================
   SQUARE Poolside — theme engine
   Ported pixel-to-pixel from the approved mockup; cart state now
   lives in Shopify (AJAX Cart API), wishlist in localStorage.
   ============================================================ */

(() => {
  const CFG = window.SQUARE || {};
  const BUNDLE_QTY = CFG.bundleQty || 3;
  const BUNDLE_PRICE = CFG.bundlePrice || 1345;
  const ROUTES = CFG.routes || { cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart' };
  const WISH_KEY = 'sq_wishlist_v1';
  const ZONE_KEY = 'sq_zone';
  const FREE_SHIP_MIN = CFG.freeShipMin || 1800;

  const ZONES = [
    { id: 'cai', name: 'Cairo & Giza', rate: 100, days: '3–4 days', free: true },
    { id: 'alx', name: 'Alexandria', rate: 120, days: '3–4 days', free: true },
    { id: 'canal', name: 'Canal — Port Said, Ismailia, Suez', rate: 160, days: '4–5 days', free: false },
    { id: 'delta', name: 'Delta governorates', rate: 160, days: '4–5 days', free: false },
    { id: 'nupper', name: 'Beni Suef, Fayoum, Minya', rate: 175, days: '4–5 days', free: false },
    { id: 'supper', name: 'Assiut, Sohag, Qena, Luxor, Aswan', rate: 220, days: '4–5 days', free: false },
    { id: 'matrouh', name: 'North Coast — Matrouh', rate: 260, days: '4–5 days', free: false },
    { id: 'remote', name: 'Red Sea, New Valley & Sinai', rate: 300, days: '4–5 days', free: false },
    { id: 'ksa', name: 'Saudi Arabia (Express)', rate: 990, days: '5 days', free: false },
  ];

  const ICONS = {
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
  };

  const fmt = (n) => Math.round(n).toLocaleString('en-US');
  const money = (cents) => `${fmt(cents / 100)} EGP`;
  const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');

  let CART = null; // latest cart.js payload

  /* ---------------- Cart API ---------------- */
  async function fetchCart() {
    const res = await fetch(`${ROUTES.cart}.js`);
    CART = await res.json();
    return CART;
  }
  async function addItems(items) {
    const res = await fetch(`${ROUTES.cartAdd}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Could not add to cart');
    }
    return fetchCart();
  }
  async function changeLine(line, quantity) {
    await fetch(`${ROUTES.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    return fetchCart();
  }

  /* ---------------- Toasts ---------------- */
  function toastZone() {
    let z = document.querySelector('.toast-zone');
    if (!z) {
      z = document.createElement('div');
      z.className = 'toast-zone';
      z.setAttribute('aria-live', 'polite');
      document.body.appendChild(z);
    }
    return z;
  }
  function showToast(html, { timeout = 3800, className = '' } = {}) {
    const t = document.createElement('div');
    t.className = `toast ${className}`;
    t.innerHTML = html;
    toastZone().appendChild(t);
    const kill = () => {
      t.classList.add('is-leaving');
      t.addEventListener('transitionend', () => t.remove(), { once: true });
      setTimeout(() => t.remove(), 400);
    };
    const timer = setTimeout(kill, timeout);
    t.addEventListener('click', (e) => {
      if (!e.target.closest('a')) { clearTimeout(timer); kill(); }
    });
    return t;
  }

  /* ---------------- Bundle meter ---------------- */
  function meterHTML(count, discountCents, { light = false } = {}) {
    const r = count % BUNDLE_QTY;
    const unlocked = count > 0 && r === 0;
    const fill = unlocked ? 1 : r / BUNDLE_QTY;
    let txt;
    if (count === 0) {
      txt = `Any <b>${BUNDLE_QTY} towels for ${fmt(BUNDLE_PRICE)} EGP</b> — auto-applied, no code.`;
    } else if (unlocked) {
      const saved = discountCents > 0 ? money(discountCents) : `${fmt(275 * Math.floor(count / BUNDLE_QTY))} EGP`;
      txt = `<b>Bundle unlocked!</b> You're saving <b>${saved}</b>.`;
    } else {
      const need = BUNDLE_QTY - r;
      txt = `Add <b>${need} more towel${need > 1 ? 's' : ''}</b> to unlock <b>${BUNDLE_QTY} for ${fmt(BUNDLE_PRICE)} EGP</b>.`;
    }
    const pips = Array.from({ length: BUNDLE_QTY }, (_, i) =>
      `<span class="${(unlocked || i < r) ? 'on' : ''}"></span>`).join('');
    return `
      <div class="bundle-meter ${light ? 'bundle-meter--light' : ''} ${unlocked ? 'is-unlocked' : ''}">
        <div class="bundle-meter__row">
          <p class="bundle-meter__txt">${txt}</p>
          <div class="bundle-meter__pips" aria-hidden="true">${pips}</div>
        </div>
        <div class="bundle-meter__bar"><div class="bundle-meter__fill" style="transform:scaleX(${fill})"></div></div>
      </div>`;
  }

  /* ---------------- Drawer ---------------- */
  let lastFocus = null;
  function openDrawer() {
    lastFocus = document.activeElement;
    document.querySelectorAll('.toast').forEach((t) => t.remove());
    document.querySelector('.backdrop')?.classList.add('is-open');
    const d = document.getElementById('cart-drawer');
    if (!d) { window.location.href = ROUTES.cart; return; }
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderDrawer();
    d.querySelector('[data-drawer-close]')?.focus({ preventScroll: true });
  }
  function closeDrawer() {
    document.querySelector('.backdrop')?.classList.remove('is-open');
    document.getElementById('cart-drawer')?.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  function renderDrawer() {
    const body = document.getElementById('drawer-body');
    const foot = document.getElementById('drawer-foot');
    if (!body || !CART) return;
    const c = CART;
    document.getElementById('drawer-count').textContent = c.item_count ? `(${c.item_count})` : '';

    if (!c.items.length) {
      body.innerHTML = `
        <div class="drawer__empty">
          <p class="display">It's empty in here</p>
          <p>Your beach day is ${BUNDLE_QTY} towels away — any ${BUNDLE_QTY} for ${fmt(BUNDLE_PRICE)} EGP.</p>
          <p style="margin-top:1.5rem"><a class="btn btn--primary" href="/collections/beach-towels">Shop towels</a></p>
        </div>`;
      foot.hidden = true;
      return;
    }

    const discount = c.total_discount || 0;
    body.innerHTML = `
      ${meterHTML(c.item_count, discount)}
      <ul class="cart-items">
        ${c.items.map((it, i) => `
          <li class="citem" data-line="${i + 1}">
            <a href="${it.url}"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_240x$1$2') : ''}" alt="${esc(it.product_title)}"></a>
            <div>
              <p class="citem__name"><a href="${it.url}">${esc(it.product_title)}</a></p>
              <p class="citem__unit">${money(it.price)}</p>
              <div class="stepper" aria-label="Quantity for ${esc(it.product_title)}">
                <button data-step="-1" aria-label="Decrease quantity">${ICONS.minus}</button>
                <output>${it.quantity}</output>
                <button data-step="1" aria-label="Increase quantity">${ICONS.plus}</button>
              </div>
            </div>
            <div class="citem__end">
              <span class="citem__line">${money(it.final_line_price)}</span>
              <button class="citem__rm" data-remove>Remove</button>
            </div>
          </li>`).join('')}
      </ul>`;

    foot.hidden = false;
    foot.innerHTML = `
      <div class="totals">
        <div class="row"><span>Subtotal (${c.item_count} towel${c.item_count > 1 ? 's' : ''})</span><span class="num">${money(c.original_total_price)}</span></div>
        ${discount > 0 ? `<div class="row discount"><span>Beach Towel Bundle</span><span class="num">−${money(discount)}</span></div>` : ''}
        <div class="row grand"><span>Total</span><span class="num">${money(c.total_price)}</span></div>
      </div>
      <form action="${ROUTES.cart}" method="post">
        <button class="btn btn--primary" name="checkout" style="width:100%">Checkout · ${money(c.total_price)}</button>
      </form>
      <div class="drawer__pay">
        <span class="paychip">CASH ON DELIVERY</span><span class="paychip">VISA</span><span class="paychip">MASTERCARD</span>
      </div>`;

    body.querySelectorAll('.citem').forEach((li) => {
      const line = Number(li.dataset.line);
      const item = c.items[line - 1];
      li.querySelectorAll('[data-step]').forEach((btn) =>
        btn.addEventListener('click', async () => {
          await changeLine(line, Math.max(0, item.quantity + Number(btn.dataset.step)));
          renderAllCartUI(); renderDrawer();
        }));
      li.querySelector('[data-remove]').addEventListener('click', async () => {
        await changeLine(line, 0);
        renderAllCartUI(); renderDrawer();
      });
    });
  }

  /* ---------------- Add-to-cart + nudge choreography ---------------- */
  async function addToCart(variantId, qty = 1, title = '') {
    const before = CART ? CART.item_count : (CFG.cartCount || 0);
    try {
      await addItems([{ id: Number(variantId), quantity: qty }]);
    } catch (e) {
      showToast(`⚠️ ${esc(e.message)}`);
      return;
    }
    const after = CART.item_count;
    renderAllCartUI();
    const bundlesBefore = Math.floor(before / BUNDLE_QTY);
    const bundlesAfter = Math.floor(after / BUNDLE_QTY);

    if (bundlesAfter > bundlesBefore) {
      openDrawer();
    } else if (after === 1 || after === 2) {
      const need = BUNDLE_QTY - after;
      const pips = Array.from({ length: BUNDLE_QTY }, (_, i) => `<span class="${i < after ? 'on' : ''}"></span>`).join('');
      showToast(`
        <div>
          <b>${esc(title || 'Added')}</b> — nice pick.<br>
          Add <b>${need} more</b> and pay <b>${fmt(BUNDLE_PRICE)} EGP</b> for all ${BUNDLE_QTY}.
          <div class="pips" aria-hidden="true">${pips}</div>
          <p style="margin-top:.5rem"><a href="/collections/beach-towels">Complete the bundle →</a></p>
        </div>`, { className: 'toast--nudge', timeout: 5200 });
    } else {
      showToast(`<span class="toast__check">${ICONS.check}</span> <b>${esc(title || 'Added')}</b> added to cart`);
    }
  }

  function renderAllCartUI() {
    const n = CART ? CART.item_count : (CFG.cartCount || 0);
    document.querySelectorAll('.cart-count:not(.wish-count)').forEach((b) => {
      b.textContent = n;
      b.classList.toggle('is-on', n > 0);
      b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump');
    });
    const discount = CART ? CART.total_discount : 0;
    document.querySelectorAll('[data-meter-mount]').forEach((m) => {
      m.innerHTML = meterHTML(n, discount, { light: m.dataset.meterMount === 'light' });
    });
    const bar = document.querySelector('.bundle-bar');
    if (bar) {
      bar.querySelector('[data-bar-meter]').innerHTML = meterHTML(n, discount);
      bar.classList.toggle('is-on', n > 0);
    }
  }

  /* ---------------- Wishlist ---------------- */
  const getWish = () => { try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; } catch { return []; } };
  const setWish = (list) => { localStorage.setItem(WISH_KEY, JSON.stringify(list)); renderWishBadges(); };

  function renderWishBadges() {
    const n = getWish().length;
    document.querySelectorAll('.wish-count').forEach((b) => {
      b.textContent = n;
      b.classList.toggle('is-on', n > 0);
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      btn.classList.toggle('is-on', getWish().includes(btn.dataset.wishlistToggle));
    });
  }

  function toggleWish(handle, btn) {
    const list = getWish();
    const i = list.indexOf(handle);
    if (i >= 0) { list.splice(i, 1); } else { list.push(handle); }
    setWish(list);
    if (btn) { btn.classList.remove('pop'); void btn.offsetWidth; btn.classList.add('pop'); }
    if (i < 0) showToast(`<span class="toast__check">${ICONS.check}</span> Saved to your <a href="/pages/wishlist" style="text-decoration:underline">wishlist</a>`);
  }

  async function initWishlistPage() {
    const grid = document.getElementById('wishlist-grid');
    const empty = document.getElementById('wishlist-empty');
    if (!grid) return;
    const handles = getWish();
    if (!handles.length) { empty.hidden = false; grid.hidden = true; return; }
    empty.hidden = true; grid.hidden = false;
    const cards = await Promise.all(handles.map(async (h) => {
      try {
        const p = await (await fetch(`/products/${h}.js`)).json();
        const v = p.variants[0];
        const img = p.images[0] ? p.images[0].replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2') : '';
        const alt = p.images[1] ? p.images[1].replace(/(\.[a-z]+)(\?|$)/, '_600x$1$2') : null;
        return `
          <article class="pcard" data-handle="${h}">
            <div class="pcard__media">
              <button class="wish-btn is-on" data-wishlist-toggle="${h}" aria-label="Remove from wishlist">
                <svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.7"><path d="M12 20s-7.5-4.7-9.3-9A5.4 5.4 0 0 1 12 6.6 5.4 5.4 0 0 1 21.3 11c-1.8 4.3-9.3 9-9.3 9Z"/></svg>
              </button>
              <img class="main ${alt ? 'has-alt' : ''}" src="${img}" alt="${esc(p.title)}" loading="lazy">
              ${alt ? `<img class="alt" src="${alt}" alt="" loading="lazy" aria-hidden="true">` : ''}
              ${v.available ? `<button class="pcard__quick" data-add="${v.id}" data-title="${esc(p.title)}">Add · ${money(v.price)}</button>` : '<span class="pcard__quick" style="opacity:.7">Sold out</span>'}
            </div>
            <div class="pcard__info">
              <h3 class="pcard__name"><a href="/products/${h}">${esc(p.title)}</a></h3>
              <p class="pcard__price">
                ${v.compare_at_price > v.price ? `<span class="was">${fmt(v.compare_at_price / 100)}</span>` : ''}
                <span class="now">${money(v.price)}</span>
              </p>
            </div>
          </article>`;
      } catch { return ''; }
    }));
    grid.innerHTML = cards.join('');
  }

  /* ---------------- Header / nav / reveals ---------------- */
  function initHeader() {
    const header = document.querySelector('.header');
    if (header) {
      const onScroll = () => header.classList.toggle('is-stuck', window.scrollY > 8);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    const toggle = document.querySelector('.nav-toggle');
    const nav = document.querySelector('.header__nav');
    toggle?.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    nav?.addEventListener('click', (e) => {
      if (e.target.closest('a')) {
        nav.classList.remove('is-open');
        toggle?.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  function initReveals(root = document) {
    if (!('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    root.querySelectorAll('.reveal, .reveal-item').forEach((el) => io.observe(el));
  }

  /* ---------------- Bundle builder (home) ---------------- */
  function initBuilder() {
    const picker = document.getElementById('builder-picker');
    if (!picker) return;
    const slotsEl = document.querySelectorAll('#builder-slots .slot');
    const totalEl = document.getElementById('builder-total');
    const wasEl = document.getElementById('builder-was');
    const saveEl = document.getElementById('builder-save');
    const hintEl = document.getElementById('builder-hint');
    const ctaEl = document.getElementById('builder-cta');
    const unitPrice = Number(picker.dataset.unitPrice || 540);
    const reference = Number(CFG.bundleReference || 1800);
    let picked = []; // [{variantId, image, title}]

    function render() {
      slotsEl.forEach((slot, i) => {
        const pick = picked[i];
        slot.classList.toggle('is-filled', !!pick);
        slot.innerHTML = pick
          ? `<img src="${pick.image}" alt="${esc(pick.title)}"><span class="slot__x" aria-hidden="true">${ICONS.x}</span>`
          : `<span aria-hidden="true">${i + 1}</span>`;
        slot.setAttribute('aria-label', pick ? `Remove ${pick.title} from bundle` : `Bundle slot ${i + 1} — empty`);
      });
      picker.querySelectorAll('.pick').forEach((el) => {
        el.classList.toggle('is-picked', picked.some((p) => p.variantId === el.dataset.variantId));
      });
      const n = picked.length;
      if (n < BUNDLE_QTY) {
        totalEl.innerHTML = `${fmt(n * unitPrice)}<span class="cur">EGP</span>`;
        wasEl.textContent = '';
        saveEl.classList.remove('is-on');
        hintEl.textContent = n === 0
          ? `Tap any ${BUNDLE_QTY} designs below — mix them however you like.`
          : `${BUNDLE_QTY - n} more pick${n === BUNDLE_QTY - 1 ? '' : 's'} and the price drops to ${fmt(BUNDLE_PRICE)} EGP.`;
        ctaEl.disabled = true;
        ctaEl.textContent = `Pick ${BUNDLE_QTY - n} more`;
      } else {
        totalEl.innerHTML = `${fmt(BUNDLE_PRICE)}<span class="cur">EGP</span>`;
        wasEl.textContent = fmt(reference);
        saveEl.classList.add('is-on');
        hintEl.textContent = 'Bundle ready. The discount applies automatically in your cart.';
        ctaEl.disabled = false;
        ctaEl.textContent = `Add bundle to cart · ${fmt(BUNDLE_PRICE)} EGP`;
      }
    }

    picker.addEventListener('click', (e) => {
      const el = e.target.closest('.pick');
      if (!el) return;
      const id = el.dataset.variantId;
      const i = picked.findIndex((p) => p.variantId === id);
      if (i >= 0) picked.splice(i, 1);
      else if (picked.length < BUNDLE_QTY) picked.push({ variantId: id, image: el.dataset.image, title: el.dataset.title });
      render();
    });
    slotsEl.forEach((slot, i) => slot.addEventListener('click', () => {
      if (picked[i]) { picked.splice(i, 1); render(); }
    }));
    ctaEl.addEventListener('click', async () => {
      if (picked.length !== BUNDLE_QTY) return;
      ctaEl.disabled = true;
      try {
        await addItems(picked.map((p) => ({ id: Number(p.variantId), quantity: 1 })));
        picked = [];
        render();
        renderAllCartUI();
        openDrawer();
      } catch (e) {
        showToast(`⚠️ ${esc(e.message)}`);
        ctaEl.disabled = false;
      }
    });
    render();
  }

  /* ---------------- PDP ---------------- */
  function initProduct() {
    const buy = document.getElementById('pdp-buy');
    if (!buy) return;
    let qty = 1;
    const qtyOut = document.getElementById('pdp-qty');
    document.getElementById('pdp-minus')?.addEventListener('click', () => { qty = Math.max(1, qty - 1); qtyOut.textContent = qty; });
    document.getElementById('pdp-plus')?.addEventListener('click', () => { qty = Math.min(10, qty + 1); qtyOut.textContent = qty; });

    const addBtn = document.getElementById('pdp-add');
    addBtn?.addEventListener('click', () => addToCart(addBtn.dataset.variantId, qty, addBtn.dataset.title));
    const barBtn = document.getElementById('buybar-add');
    barBtn?.addEventListener('click', () => addToCart(barBtn.dataset.variantId, qty, barBtn.dataset.title));

    // gallery — warm every full-size image up front so thumb swaps are instant
    const main = document.getElementById('pdp-main-img');
    const thumbs = document.getElementById('pdp-thumbs');
    if (thumbs) {
      const warm = () => thumbs.querySelectorAll('.pdp__thumb').forEach((b) => {
        const img = new Image();
        img.src = b.dataset.full;
      });
      'requestIdleCallback' in window ? requestIdleCallback(warm, { timeout: 2000 }) : setTimeout(warm, 600);

      thumbs.addEventListener('click', (e) => {
        const btn = e.target.closest('.pdp__thumb');
        if (!btn || btn.classList.contains('is-active')) return;
        thumbs.querySelectorAll('.pdp__thumb').forEach((t) => t.classList.toggle('is-active', t === btn));
        const next = new Image();
        next.src = btn.dataset.full;
        main.classList.add('is-swapping');
        const started = performance.now();
        const apply = () => {
          // keep the blur on at least 150ms so cached swaps still read as a crossfade
          const wait = Math.max(0, 150 - (performance.now() - started));
          setTimeout(() => {
            main.src = next.src;
            main.classList.remove('is-swapping');
          }, wait);
        };
        if (next.complete && next.naturalWidth > 0) apply();
        else { next.onload = apply; next.onerror = apply; }
      });
    }

    // trio
    const trioAdd = document.getElementById('trio-add');
    trioAdd?.addEventListener('click', async () => {
      const ids = JSON.parse(trioAdd.dataset.variantIds || '[]');
      if (!ids.length) return;
      trioAdd.disabled = true;
      try {
        await addItems(ids.map((id) => ({ id: Number(id), quantity: 1 })));
        renderAllCartUI();
        openDrawer();
      } catch (e) { showToast(`⚠️ ${esc(e.message)}`); }
      trioAdd.disabled = false;
    });

    // sticky mobile buy bar
    const buybar = document.querySelector('.buybar');
    if (buybar) {
      new IntersectionObserver(([e]) => {
        buybar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(buy);
    }
  }

  /* ---------------- Boot ---------------- */
  document.addEventListener('DOMContentLoaded', async () => {
    initHeader();
    initReveals();
    renderWishBadges();

    // shared delegation
    document.addEventListener('click', (e) => {
      const add = e.target.closest('[data-add]');
      if (add) { e.preventDefault(); addToCart(add.dataset.add, 1, add.dataset.title || ''); return; }
      const cartOpen = e.target.closest('[data-cart-open]');
      if (cartOpen) { e.preventDefault(); fetchCart().then(() => { renderAllCartUI(); openDrawer(); }); return; }
      const close = e.target.closest('[data-drawer-close]');
      if (close) { closeDrawer(); return; }
      const wish = e.target.closest('[data-wishlist-toggle]');
      if (wish) { e.preventDefault(); toggleWish(wish.dataset.wishlistToggle, wish); return; }
    });
    document.querySelector('.backdrop')?.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.getElementById('cart-drawer')?.classList.contains('is-open')) closeDrawer();
    });

    initBuilder();
    initProduct();
    initWishlistPage();

    await fetchCart();
    renderAllCartUI();
  });
})();
